import {Component, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {ToastrService} from 'ngx-toastr';
import moment from 'moment';
import {LoaderService} from '@app/shared/services';
import {UserManagementService} from '@app/shared/services/user-management.service';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent
  ],
  animations: [routerTransition()]
})
export class UserManagementComponent implements OnInit {
  public user_groups: any = [];
  public userlist: any = [];
  public user_rights: any = {};
  public drFlag = 0;
  public now = new Date();
  public date: any;
  public formData = {
    firstname: '',
    lastname: '',
    username: '',
    password: '',
    useraccesstype: '',
    user_id: '',
    email: '',
    date: '',
    status: 1
  };
  success_message = '';
  error_message = '';

  constructor(
    public userManagementService: UserManagementService,
    private toastr: ToastrService,
    private loaderService: LoaderService) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.getOptions();
    this.getUserList();
    this.formatDateTime();
  }

  editUser(user: any) {
    window.scrollTo(0, 0);
    this.formData.firstname = user.FIRSTNAME;
    this.formData.lastname = user.LASTNAME;
    this.formData.email = user.EMAIL;
    this.formData.username = user.USERNAME;
    this.formData.user_id = user.USER_SPK;
    this.formData.useraccesstype = user.USER_ACCESS_TYPE;
    this.formData.status = user.STATUS;
  }

  updateUserData(): any {
    if (this.formData.firstname == '') {
      this.toastr.error('Please enter first name !');
      return false;
    } else if (this.formData.lastname == '') {
      this.toastr.error('Please enter last name !');
      return false;
    } else if (this.formData.email == '') {
      this.toastr.error('Please enter email id !');
      return false;
    } else if (this.formData.useraccesstype == '') {
      this.toastr.error('Please enter group !');
      return false;
    } else if (this.formData.user_id == '' && this.formData.password == '') {
      this.toastr.error('Please enter your password !');
      return false;
    } else {
      this.loaderService.display(true);
      this.userManagementService.addNewUser(this.formData).subscribe((result: any) => {
        this.loaderService.display(false);
        window.scrollTo(0, 0);
        if (result['status'] == 'Success') {

          this.getUserList();
          this.toastr.success(result["message"], result.response);
          this.formData = {
            firstname: '',
            lastname: '',
            username: '',
            password: '',
            useraccesstype: '',
            user_id: '',
            email: '',
            date: '',
            status: 1
          };
          this.drFlag = 0;

        } else {
          this.toastr.error(result["message"]);
        }
      });
    }
  }

  getUserList() {
    this.loaderService.display(true);
    this.userManagementService.getUserList().subscribe((data: any) => {
      this.loaderService.display(false);
      if (data['status'] == 'Success') {
        this.userlist = data['data'];
      }

    });
  }

  getOptions() {
    this.userManagementService.getOptions().subscribe((data: any) => {
      if (data['status'] == 'Success') {
        if (data['user_groups']['status'] == 'Success') {
          this.user_groups = data['user_groups']['data'];
        }
      }
    });
  }

  public formatDateTime() {

    const retVal = '';
    if (this.now) {
      this.formData.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y h:mm a');
    }
    return retVal;


  }
}
